/**
 * `data-testid`s owned by the W2-authored terminal screens.
 *
 * NOTE (finding #6): the reused register / login / profile / PHQ screens render
 * the **B2C** testids (`registration-form`, `login-form`, `onboarding-next`, …),
 * NOT W2-specific ones — the e2e suite selects on those B2C testids via
 * `e2e/w2-phq/contract.ts` (`TID`). The only testids the W2 code renders itself
 * are the terminal `done` and `linkError` screens below (`W2Done` / `W2LinkError`),
 * so those are the only ones kept here. Keep the string values identical to the
 * contract the specs assert on.
 */
export const W2_TID = {
  header: {
    /** Permanent employee-session action in every authenticated W2 header. */
    logout: 'w2-header-logout',
  },
  done: {
    root: 'w2-done',
    message: 'w2-done-message',
  },
  /** Waiver modal (spec screen 2) — required answer, hidden NEXT, gated Submit. */
  waiver: {
    root: 'w2-waiver',
    coverage: 'w2-waiver-coverage',
    waive: 'w2-waiver-waive',
    certify: 'w2-waiver-certify',
    submit: 'w2-waiver-submit',
    error: 'w2-waiver-error',
  },
  linkError: {
    root: 'w2-link-error',
    title: 'w2-link-error-title',
  },
  /**
   * W2-host lockdown block screen (token-less B2C route reached on a W2 host).
   * Distinct from `linkError` (which is about token VALIDITY) — this is the
   * "reach a B2C surface you're not allowed to" branded full-page error.
   */
  blocked: {
    root: 'w2-blocked',
    title: 'w2-blocked-title',
    /** Neutral loading shell shown while the host type is still unresolved. */
    loading: 'w2-host-gate-loading',
  },
  /** Resolve-outage screen (transport failure ≠ invalid link, arch W3/F3). */
  loadError: {
    root: 'w2-load-error',
    retry: 'w2-retry',
  },
  /** flow-layout seam: present ⇔ the C-7.1 gate passed for the current token. */
  flow: {
    root: 'w2-flow-root',
  },
} as const;
